import { makeStyles } from "@material-ui/core/styles";


export const useStyleCard = makeStyles({
    root: {
      width: 345,
      height: "fit-content"
    },
  });